// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../../styles/variables.css\"","secondaryLight":"#7FE7AB","recovery-wrapper":"jVSU9wQ9NvDxiE2GVaTUd","recovery-container":"uvTKS4CH5rYnFqJKr3OFH","client":"ckELZsjxTPXvYY-e084fq","reset-recovery":"_7kAUoC0EWkqfWvZGUMSv6","rotatable":"rWNttwfYBvt9zkVK3Uy-b","recovery-time":"HjxdYrpl38jo7FY_3Tbf4","reset-recovery-time":"TUoO-cLuj2OX37VR3XTdj"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/RecoveryPlan/components/RecoveryClock.mod.css
// module id = 1033
// module chunks = 0